export default __webpack_public_path__ + "static/media/sound-on.c479afbd.svg";